import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { PrequalificationModel } from 'src/app/models/prequalification.model';
import { PrequalificationService } from 'src/app/prequalifications/prequalification.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/utils.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-client-pre-qualifications-view',
  templateUrl: './client-pre-qualifications-view.component.html',
  styleUrls: ['./client-pre-qualifications-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientPreQualificationsViewComponent implements OnInit {
  prequal = new PrequalificationModel();
  score: number;
  shareLink: string;
  readonly baseUrl = window.location.origin;

  constructor(
    @Inject(MAT_DIALOG_DATA) private id: number,
    private prequalService: PrequalificationService,
    private utils: UtilsService
  ) {}

  ngOnInit() {
    this.prequalService.find(this.id, true).subscribe((response) => {
      this.prequal = response.data;
      this.shareLink =
        window.location.origin +
        `/noauth/prequalifications/${this.prequal.hash}`;
    });
  }

  async downloadPdf() {
    const data = await this.prequalService.exportPdf(this.prequal.id);
    saveAs(data, `Prequalification ${this.prequal.name}`);
  }

  notifyCopied() {
    this.utils.showToast('Copied link to clipboard');
  }

  onOpenUrl(url: string) {
    this.utils.openUrl(url);
  }
}
